// @ts-nocheck
import React from 'react';
import { useStudentNameOrder } from '../utils/studentSort';

// Dropdown control to switch student list sorting between first/last name.
export default function StudentNameOrderToggle({ style }: any) {
  const [order, setOrder] = useStudentNameOrder();

  return (
    <label style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 13, color: '#334155', ...style }}>
      Sort by:
      <select
        value={order}
        onChange={(e) => setOrder(e.target.value)}
        style={{ padding: '4px 8px', borderRadius: 6, border: '1px solid #cbd5e1', fontSize: 13 }}
      >
        <option value="last">Last name</option>
        <option value="first">First name</option>
      </select>
    </label>
  );
}
